import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography'
import EditIcon from '@mui/icons-material/Edit';
import Divider from '@mui/material/Divider';
import ArchiveIcon from '@mui/icons-material/Archive';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Link, useNavigate } from 'react-router';

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: 'rgb(55, 65, 81)',
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
        ...theme.applyStyles('dark', {
          color: 'inherit',
        }),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
    ...theme.applyStyles('dark', {
      color: theme.palette.grey[300],
    }),
  },
}));

export default function WhoWeAreNav({recolor}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const navigate = useNavigate()
  const handleClose = () => {
    setAnchorEl(null);
  };

  const formatName = (str) =>
    str
      ?.replace(/[-_]/g, " ")
      .split(" ")
      .map(w => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");

  return (
    <div>
      <Button
        id="demo-customized-button"
        sx={{
          color: `${recolor?'#ffff':'#1565c0'}`,
          fontWeight: 600,
          fontSize:15,
          textTransform: 'none',
          '&:hover': {
            backgroundColor: 'transparent',
            color: `${recolor?'#c18078':'#1565c0'}`,
          },
          // margingRight:2,
        // padding:2,
        }}
        aria-controls={open ? 'demo-customized-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="text"
        disableElevation
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
        secondary
      >
        Who We Are
      </Button>
      <StyledMenu
        id="demo-customized-menu"
        slotProps={{
          list: {
            'aria-labelledby': 'demo-customized-button',
          },
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={()=>{
          handleClose()
          navigate("/who-we-are#about-us")
          // handleClose
          }} 
        
        disableRipple
        sx={{
          borderRadius: 2,
          mb: 0.5,
          display: "flex",
          alignItems: "center",
          gap: 1,
          "&:hover": {
            backgroundColor: "#c18078",
            color: "primary.contrastText",
          },
        }}
        >
          
          <Typography variant="body2" sx={{ fontWeight: 700 }}>
            {formatName("About Us")}
          </Typography>
        </MenuItem>
        <MenuItem onClick={()=>{
          handleClose()
          navigate("/who-we-are#our-values")
          // handleClose
          }}  
          disableRipple
          sx={{
            borderRadius: 2,
            mb: 0.5,
            display: "flex",
            alignItems: "center",
            gap: 1,
            "&:hover": {
              backgroundColor: "#c18078",
              color: "primary.contrastText",
            },
          }}
          >
          <FileCopyIcon />
          
          <Typography variant="body2" sx={{ fontWeight: 700 }}>
            {formatName("Our Values")}
          </Typography>
        </MenuItem>
        <Divider sx={{ my: 0.5 }} />
        
        <MenuItem onClick={()=>{
          handleClose()
          navigate("/who-we-are#our-mission")
          // handleClose
          }} 
          disableRipple
          
            sx={{
              borderRadius: 2,
              mb: 0.5,
              display: "flex",
              alignItems: "center",
              gap: 1,
              "&:hover": {
                backgroundColor: "#c18078",
                color: "primary.contrastText",
              },
            }}
          >
          <ArchiveIcon />
          
          <Typography variant="body2" sx={{ fontWeight: 700 }}>
            {formatName("Our Mission")}
          </Typography>
        </MenuItem>


        <MenuItem onClick={()=>{
          handleClose()
          navigate("/who-we-are#our-vision")
          // handleClose
          }} 
          disableRipple
          sx={{
            borderRadius: 2,
            mb: 0.5,
            display: "flex",
            alignItems: "center",
            gap: 1,
            "&:hover": {
              backgroundColor: "#c18078",
              color: "primary.contrastText",
            },
          }}
          >
          <ArchiveIcon />
          
          <Typography variant="body2" sx={{ fontWeight: 700 }}>
            {formatName("Our Vision")}
          </Typography>
        </MenuItem>

        <MenuItem 
        onClick={()=>{
          handleClose()
          navigate("/who-we-are#our-leadership")
          // handleClose
          }}
        disableRipple
        sx={{
          borderRadius: 2,
          mb: 0.5,
          display: "flex",
          alignItems: "center",
          gap: 1,
          "&:hover": {
            backgroundColor: "#c18078",
            color: "primary.contrastText",
          },
        }}
        >
          <MoreHorizIcon />
          
          <Typography variant="body2" sx={{ fontWeight: 700 }}>
            {formatName("Our Team")}
          </Typography>
        </MenuItem>
      </StyledMenu>
    </div>
  );
}